import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { authenticatedRoute } from '@/router/authenticated-route';

/**
 * App de OKRs (EU-756), em `/okrs`.
 *
 * Três coisas de propósito:
 *
 * 1. **Sem entrada de navegação.** Não há item de menu, card nem link para cá
 *    em lugar nenhum do App Consultor — o acesso é por link direto (RN-03).
 * 2. **Sem `requireWorkspace`.** OKR é da Eureca, não de uma empresa cliente:
 *    exigir uma área de trabalho selecionada não faria sentido.
 * 3. **Carga preguiçosa.** O dashboard é grande e serve a um punhado de
 *    diretores; `lazyRouteComponent` mantém esse peso fora do bundle de quem
 *    nunca abre esta rota.
 *
 * O gate de acesso NÃO está aqui: quem decide é o BFF, e a página mostra a tela
 * de acesso negado a partir do 403 dele (RN-10). Um `beforeLoad` que chamasse a
 * sessão só duplicaria a mesma resposta mais cedo.
 */
export const okrsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/okrs',
  component: lazyRouteComponent(() => import('@/features/okrs/OkrPage')),
});
